module.exports = __webpack_public_path__ + "img/icon-ayato.30238213.webp";